import { render } from "./OnlineBookingList.vue?vue&type=template&id=0d3a5128"
import script from "./OnlineBookingList.vue?vue&type=script&lang=js"
export * from "./OnlineBookingList.vue?vue&type=script&lang=js"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__